var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___bmxmbk",
  "yF": "AutocompleteEmoji.module__divider___bmxmbk",
  "mI": "AutocompleteEmoji.module__emojiIcon___bmxmbk",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___bmxmbk",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___bmxmbk",
  "lA": "AutocompleteEmoji.module__stickerIcon___bmxmbk",
  "Cu": "AutocompleteEmoji.module__memeIcon___bmxmbk",
  "_Q": "AutocompleteEmoji.module__memeVideo___bmxmbk",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___bmxmbk",
  "iw": "AutocompleteEmoji.module__audioIcon___bmxmbk",
};

module.exports = exports;
